<template>
  <div>
    <header class="app_h">
      <img
        class="left"
        src="../../assets/images/index/GooglePlay-left.png"
        alt=""
      >
      <img
        class="right"
        src="../../assets/images/index/GooglePlay-right.png"
        alt=""
      >
    </header>
    <div class="dowloadApp">
      <div class="content">
        <div class="download">
          <div class="download_h">
            <img
              src="../../../app_logo.png"
              alt=""
            >
            <div class="flex-1 download_M">
              <p class="text-2xl">
                {{ $store.state.config.site_name }}.COM
              </p>
              <p class="text-xl">
                {{ $store.state.config.site_name }}.COM LTD CO.
              </p>
              <p>Verificado pelo aplicativo</p>
            </div>
          </div>
          <div class="download_center">
            <div class="items">
              <p class="text_1">
                4.9 ★
              </p>
              <p class="text_2">
                8M reviews
              </p>
            </div>
            <i class="line" />
            <div class="items">
              <p class="text_1">
                100M +
              </p>
              <p class="text_2">
                Baixando
              </p>
            </div>
            <i class="line" />
            <div class="items">
              <p class="text_1">
                18+
              </p>
              <p class="text_2">
                Rated for 18+
              </p>
            </div>
          </div>
          <div
            class="download_btn"
            :class="{ 'installing': installing, 'installed': isInstalled }"
            @click="installPWA"
          >
            <div class="btn_h">
              <img
                v-if="!installing"
                src="../../assets/images/index/ic_sd.png"
                alt=""
              >
              <div
                v-else
                class="loading-spinner"
              >
                ⏳
              </div>
              <span v-if="!installing && !isInstalled">Rapid Instalar</span>
              <span v-else-if="installing">Instalando...</span>
              <span v-else-if="isInstalled">✅ Instalado</span>
            </div>
            <div class="btn_b">
              <span v-if="!installing && !isInstalled">Baixe dentro de 15 segundos</span>
              <span v-else-if="installing">Aguarde um momento...</span>
              <span v-else-if="isInstalled">App disponível na tela inicial</span>
            </div>
          </div>
          <div class="download_bottom">
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              class="s-ion-icon"
              fill="currentcolor"
            >
              <path
                d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
              />
            </svg>
            <span>Compartilhar</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              class="s-ion-icon"
              fill="currentcolor"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z"
              />
            </svg>
            <span>Adicionar à lista de desejos</span>
          </div>
        </div>
        <div class="img_box">
          <div class="publicUrl">
            <el-image
              style="width: 100%; height: 100%"
              :src="url"
              :preview-src-list="srcList"
            />
          </div>
        </div>
        <div class="text_box">
          <div class="text_title">
            Sobre este jogo
            <img
              src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-right-arrow.png"
              alt=""
            >
          </div>
          <div class="text_content">
            <p>
              Jogar Fortune Tiger Slot oferece mais chances de ganhar mais presentes nas máquinas
              caça-níqueis!
              Animações suaves e ótimos presentes!
            </p>
          </div>
          <div
            class="text_title fontSize"
            style="margin-top: .3rem;"
          >
            Atualizado em
          </div>
          <div
            class="text_title fontSize"
            style="color: #5F6368;background: transparent;margin-top: .3rem;"
          >
            10 de fev.
            de 2025
          </div>
          <div class="tag_box">
            <div class="tag_item">
              Cassino
            </div>
            <div class="tag_item">
              Caça-níqueiss
            </div>
          </div>
          <div
            class="text_title"
            style="margin-top: .5rem;"
          >
            Segurança dos dados
            <img
              src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-right-arrow.png"
              alt=""
            >
          </div>
          <div
            class="text_content"
            style="padding-top: .3rem;"
          >
            Sua segurança começa com o entendimento de como os desenvolvedores coletam e compartilham seus
            dados. As
            práticas de segurança e privacidade de dados podem variar de acordo com o uso, a região e a
            idade. O
            desenvolvedor forneceu as informações a seguir, que podem ser atualizadas ao longo do tempo.
          </div>
          <div class="rounded">
            <div class="item_box">
              <div
                class="item_img"
                style="width: 0.8rem;"
              >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/ic_share.png"
                  alt=""
                >
              </div>
              <div class="item_text">
                <p>Este app pode compartilhar estes tipos de dados com terceiros</p>
                <p>Local, Informações financeiras e Identificadores do dispositivo e outros</p>
              </div>
            </div>
            <div class="item_box">
              <div
                class="item_img"
                style="width: 1rem;"
              >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/ic_cloud_upload.png"
                  alt=""
                >
              </div>
              <div class="item_text">
                <p>TEste app pode coletar estes tipos de dados Local, Informações pessoais e mais 5</p>
              </div>
            </div>
            <div class="item_box">
              <div
                class="item_img"
                style="width: 0.4rem;"
              >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/ic_lock.png"
                  alt=""
                >
              </div>
              <div class="item_text">
                <p>Os dados não são criptografados</p>
              </div>
            </div>
            <div class="item_box">
              <div
                class="item_img"
                style="width: 0.4rem;"
              >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/ic_delete.png"
                  alt=""
                >
              </div>
              <div class="item_text">
                <p>Você pode solicitar a exclusão dos dados</p>
              </div>
            </div>
            <div class="item_bottom_text">
              Mais detalhes
            </div>
          </div>
          <div
            class="text_title"
            style="margin-top: .5rem;"
          >
            Classificações e revisões
            <!-- <img src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-right-arrow.png" alt=""> -->
          </div>
          <div
            class="text_content"
            style="padding-top: .3rem;"
          >
            As avaliações e avaliações são verificadas e de pessoas que usam o mesmo tipo de dispositivo que
            você usa
            Telefone As avaliações e avaliações são verificadas e de pessoas que usam o mesmo tipo de
            dispositivo que
            você
            usa Telefone As avaliações e avaliações são verificadas e de pessoas que usam o mesmo tipo de
            dispositivo
            que
            você usa Telefone As avaliações e avaliações são verificadas e de pessoas que usam o mesmo tipo
            de
            dispositivo
            que você usa Telefone
          </div>
          <div
            class="tag_box"
            style="margin-top: .5rem;"
          >
            <div class="tag_item active">
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-phone.png"
                alt=""
              >
              Telephone
            </div>
            <div class="tag_item">
              Tablet
            </div>
            <div class="tag_item">
              Chromebook
            </div>
          </div>
        </div>
        <div class="fraction_box">
          <div class="fraction">
            <div class="fraction_title">
              4.9
            </div>
            <div class="fraction_star">
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                alt=""
              >
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                alt=""
              >
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                alt=""
              >
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                alt=""
              >
              <img
                src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/halfStar.png"
                alt=""
              >
            </div>
            <div class="fraction_text">
              50000
            </div>
          </div>
          <div class="progress">
            <div class="progress_b">
              5
              <div class="progress_box">
                <p class="full w-5" />
              </div>
            </div>
            <div class="progress_b">
              4
              <div class="progress_box">
                <p class="full w-4" />
              </div>
            </div>
            <div class="progress_b">
              3
              <div class="progress_box">
                <p class="full w-3" />
              </div>
            </div>
            <div class="progress_b">
              2
              <div class="progress_box">
                <p class="full w-2" />
              </div>
            </div>
            <div class="progress_b">
              1
              <div class="progress_box">
                <p class="full w-1" />
              </div>
            </div>
          </div>
        </div>
        <div class="comment">
          <div class="comment_box">
            <div class="comment_item">
              <div class="comment_top">
                <div class="comment_title">
                  <img
                    src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/images/939ff21415174dc5118eb885cf5a535c65f19ae276be1.jpeg"
                    alt=""
                  >
                  <div class="comment_name">
                    Miguel
                  </div>
                </div>
                <div class="comment_img">
                  <img
                    src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-more.png"
                    alt=""
                  >
                </div>
              </div>
              <div class="comment_star">
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <span>March 7, 2024</span>
              </div>
              <div class="comment_content">
                Jogo divertido com bônus enormes
              </div>
              <div class="help_text">
                <div class="help_content">
                  Você achou isso útil?
                </div>
                <div class="help_button">
                  <div class="button">
                    Sim
                  </div>
                  <div class="button">
                    Não
                  </div>
                </div>
              </div>
            </div>
            <div class="comment_item">
              <div class="comment_top">
                <div class="comment_title">
                  <img
                    src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/images/2569dc84ad21c232d1ad8c6c74cdaeb365f19d0a73dee.jpeg"
                    alt=""
                  >
                  <div class="comment_name">
                    viewsSystem.32
                  </div>
                </div>
                <div class="comment_img">
                  <img
                    src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-more.png"
                    alt=""
                  >
                </div>
              </div>
              <div class="comment_star">
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <img
                  src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/fullStar.png"
                  alt=""
                >
                <span>January 5, 2024</span>
              </div>
              <div class="comment_content">
                Jogo casual muito divertido, você também pode ganhar dinheiro
              </div>
              <div class="help_text">
                <div class="help_content">
                  Você achou isso útil?
                </div>
                <div class="help_button">
                  <div class="button">
                    Sim
                  </div>
                  <div class="button">
                    Não
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text_box">
          <div
            class="text_title"
            style="margin-top: .5rem;"
          >
            O que há de novo
            <!-- <img src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-right-arrow.png" alt=""> -->
          </div>
          <div
            class="text_content"
            style="padding-top: .3rem;"
          >
            <p>Olá, fãs de Fortune Tiger Slot!</p>
            <p>Aqui está uma nova atualização:</p>
            <p>-Melhorias de desempenho</p>
            <p>Aproveite e divirta-se!</p>
          </div>
          <div
            class="text_title"
            style="margin-top: .5rem;"
          >
            Jogos semelhantes
            <!-- <img src="https://pwa-install-20240320.s3.sa-east-1.amazonaws.com/assets/icons/icon-right-arrow.png" alt=""> -->
          </div>
          <div class="game_box">
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/yZ_nzWpg_cj6GYJv15YdsfWBKS6JzXGt69R8fCCj3AsapCSs5MGdr6haxPCk-Ae91g=s64-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Cash Craze: Casino Slots Games
                </div>
                <div class="game_title">
                  Casual Joy Games
                </div>
                <div class="game_star">
                  4,5star
                </div>
              </div>
            </div>
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/vHA867MF5a-0zJfHgxgKUKs4GJb8mWMLNjGpTpufUpw1IN_EuqWGY9d-qrY4keq4hw8=s64-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Charge Buffalo Slot-TaDa Jogos
                </div>
                <div class="game_title">
                  FUFAFA TECHNOLOGY LTD CO.
                </div>
                <div class="game_star">
                  4,5star
                </div>
              </div>
            </div>
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/Bi-dBVeyh-XZZ8ypCuklaHct8ClSitAAEOy3rCS3KOE50GBVsZ4ucseDKrLZExrAkfY=s64-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Jackpot Magic Slots
                </div>
                <div class="game_title">
                  Big Fish Games
                </div>
                <div class="game_star">
                  2,6star
                </div>
              </div>
            </div>
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/3C9ipO88Z92NJuohq_u6Ce6sTKHAADCfrpyVaEWz3vDO4XBscTJwAiRM9WhzS__WOybZ=s64-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Diamond Slot - Slot Game
                </div>
                <div class="game_title">
                  International Games System Co., Ltd.
                </div>
                <div class="game_star">
                  3,9star
                </div>
              </div>
            </div>
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/ESO0hEf9irZ4_SDA9KruU4irxTkjSyRCeUhWEPOROs1x2TlMqOrqB4i34M-ZPIE5XQ7W=s64-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Slots Era-TaDa Jogo
                </div>
                <div class="game_title">
                  FUFAFA TECHNOLOGY LTD CO.
                </div>
                <div class="game_star">
                  4,4star
                </div>
              </div>
            </div>
            <div class="game_item">
              <div class="game_img">
                <img
                  src="https://play-lh.googleusercontent.com/CSkRZuIZLOJZ8q0krA3qvnciiRTXZBU5Nx6nmTXM31ZUEilUf6Plz_va-IV_-pjWDgE=s128-rw"
                  alt=""
                >
              </div>
              <div class="game_content">
                <div class="game_title">
                  Infinity Slots - Casino Games
                </div>
                <div class="game_title">
                  Murka Games Limited
                </div>
                <div class="game_star">
                  4,5star
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="line" />
        <div class="app_bottom">
          <div class="bottom-1">
            <div>Google Play</div>
            <div>Play Pass</div>
            <div>Play Points</div>
            <div>Vales-presente</div>
            <div>Resgatar</div>
            <div>Política de reembolso</div>
          </div>
          <div class="bottom-2">
            <div>Termos de Serviço</div>
            <div class="last">
              Privacidade
            </div>
          </div>
          <div class="bottom-2">
            <div>Sobre o Google Play</div>
            <div class="last">
              Desenvolvedores
            </div>
          </div>
          <div class="bottom-2">
            <div>Google Store</div>
            <div class="last">
              Todos os preços incluem Tributo.
            </div>
          </div>
          <div class="bottom-3">
            <div>
              <img
                src="https://ssl.gstatic.com/store/images/regionflags/brazil.png"
                alt=""
              >
            </div>
            <div>Brasil (Português)</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <ul class="footer-tabs">
        <li>
          <div>
            <svg
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="s-ion-icon"
            >
              <g clip-path="url(#clip0_184_201)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.0571 12.4569C21.9622 11.6022 21.7883 10.7475 21.601 9.82724C21.563 9.64004 21.5243 9.45012 21.4857 9.25693C21.3714 8.68567 21.3714 8.68546 21.2571 8.22836L21.1429 7.88551C20.8 4.91408 18.2857 2.85693 15.2 2.85693H7.65714C4.68571 2.85693 2.05714 4.91408 1.6 7.88551C1.6 7.92178 1.6 7.94653 1.59634 7.97074C1.58849 8.02281 1.56373 8.07233 1.48571 8.22836C1.48571 8.68551 1.48571 8.68551 1.37143 9.25693C1.25714 9.77122 1.17143 10.3141 1.08571 10.8569C1 11.3998 0.914286 11.9426 0.8 12.4569C0.114286 16.4569 0 17.1426 0 17.3712C0 19.0855 1.37143 20.5712 3.2 20.5712C4.11429 20.5712 4.91429 20.2284 5.48571 19.6569L8.8 16.4569H14.1714L17.4857 19.7712C18.0571 20.3426 18.8571 20.6855 19.7714 20.6855C21.4857 20.6855 22.9714 19.3141 22.9714 17.4855C22.8634 17.1615 22.7554 16.5313 22.1653 13.0875L22.0571 12.4569ZM14.8571 8.57122C15.4253 8.57122 15.8857 8.11072 15.8857 7.54265C15.8857 6.97458 15.4253 6.51408 14.8571 6.51408C14.289 6.51408 13.8286 6.97458 13.8286 7.54265C13.8286 8.11072 14.289 8.57122 14.8571 8.57122ZM18.0571 9.71408C18.0571 10.2821 17.5967 10.7426 17.0286 10.7426C16.4605 10.7426 16 10.2821 16 9.71408C16 9.14601 16.4605 8.68551 17.0286 8.68551C17.5967 8.68551 18.0571 9.14601 18.0571 9.71408ZM12 9.02836C11.6571 9.37122 11.6571 10.0569 12 10.3998C12.3429 10.7426 13.0286 10.7426 13.3714 10.3998C13.7143 10.0569 13.7143 9.37122 13.3714 9.02836C13.0286 8.68551 12.4571 8.68551 12 9.02836ZM14.8571 12.9141C15.4253 12.9141 15.8857 12.4536 15.8857 11.8855C15.8857 11.3174 15.4253 10.8569 14.8571 10.8569C14.289 10.8569 13.8286 11.3174 13.8286 11.8855C13.8286 12.4536 14.289 12.9141 14.8571 12.9141ZM7.31429 6.85693H8.68571V9.02836H10.8571V10.3998H8.68571V12.5712H7.31429V10.3998H5.14286V9.02836H7.31429V6.85693ZM18.8571 18.0569C19.0857 18.2855 19.3143 18.3998 19.6571 18.3998C20.3429 18.3998 20.8 17.9426 20.8 17.2569C20.8 17.3712 19.2 8.34265 19.2 8.22836C18.8571 6.2855 17.1429 4.91408 15.2 4.91408H7.65714C5.6 4.91408 4 6.2855 3.65714 8.22836C3.65714 8.34265 2.05714 17.3712 2.05714 17.3712C2.05714 18.0569 2.62857 18.5141 3.2 18.5141C3.54286 18.5141 3.77143 18.3998 4 18.1712L7.88571 14.2855H14.9714L15.3143 14.5141L18.8571 18.0569Z"
                  fill="#5F6368"
                />
              </g>
              <defs>
                <clipPath id="clip0_184_201">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="tab_text">
            Games
          </div>
        </li>
        <li>
          <div>
            <svg
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="s-ion-icon"
            >
              <path
                d="M4 6C4 4.89543 4.89543 4 6 4H9C10.1046 4 11 4.89543 11 6V9C11 10.1046 10.1046 11 9 11H6C4.89543 11 4 10.1046 4 9V6Z"
                fill="#01875f"
              />
              <path
                d="M13 6C13 4.89543 13.8954 4 15 4H18C19.1046 4 20 4.89543 20 6V9C20 10.1046 19.1046 11 18 11H15C13.8954 11 13 10.1046 13 9V6Z"
                fill="#01875f"
              />
              <path
                d="M13 15C13 13.8954 13.8954 13 15 13H18C19.1046 13 20 13.8954 20 15V18C20 19.1046 19.1046 20 18 20H15C13.8954 20 13 19.1046 13 18V15Z"
                fill="#01875f"
              />
              <path
                d="M4 15C4 13.8954 4.89543 13 6 13H9C10.1046 13 11 13.8954 11 15V18C11 19.1046 10.1046 20 9 20H6C4.89543 20 4 19.1046 4 18V15Z"
                fill="#01875f"
              />
            </svg>
          </div>
          <div
            class="tab_text"
            style="color: rgb(1, 135, 95);"
          >
            Apps
          </div>
        </li>
        <li>
          <div>
            <svg
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="s-ion-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 2V22H21V2H3ZM5 20H19V4H5V20ZM9 7H6V5H9V7ZM18 7H15V5H18V7ZM6 19H9V17H6V19ZM18 19H15V17H18V19ZM15 15H18V13H15V15ZM9 15H6V13H9V15ZM15 11H18V9H15V11ZM9 11H6V9H9V11Z"
                fill="#5F6368"
              />
            </svg>
          </div>
          <div class="tab_text">
            Movies
          </div>
        </li>
        <li>
          <div>
            <svg
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="s-ion-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.4996 6.36584L14.001 7.65237V4H11.001V7.65075L12.4996 6.36584ZM10 2H11.001H14.001H15H16.998C18.6461 2 20.001 3.35397 20.001 5.002V18.998C20.001 20.646 18.6461 22 16.998 22H4V2H10ZM18.001 5.002C18.001 4.459 17.542 4 16.998 4H16.001V12L12.5 9L9.001 12V4H6V20H16.998C17.542 20 18.001 19.541 18.001 18.998V5.002Z"
                fill="#5F6368"
              />
            </svg>
          </div>
          <div class="tab_text">
            Books
          </div>
        </li>
        <li>
          <div>
            <svg
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="s-ion-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9995 20.439C13.1543 20.787 17.2264 22 17.6293 22C18.4311 22 18.928 21.578 19.154 21.325C19.7049 20.7081 19.7029 20.0604 19.6999 19.0794V19.074C19.6989 18.647 19.6299 16.111 19.6009 15.125C20.2258 14.252 21.8914 11.907 22.1604 11.5C22.7292 10.643 23.2201 9.901 22.8972 8.908C22.5724 7.90856 21.7594 7.61034 20.8112 7.26259L20.8096 7.262C20.3747 7.103 17.7853 6.254 16.8195 5.942C16.2026 5.107 14.518 2.848 14.221 2.476L14.2198 2.47445C13.5875 1.68311 13.0416 1 11.9995 1C10.9577 1 10.4108 1.684 9.77797 2.477C9.48103 2.848 7.79639 5.107 7.18052 5.942C6.21372 6.255 3.62427 7.103 3.18436 7.265C2.24156 7.61 1.42773 7.908 1.1028 8.908C0.779872 9.901 1.27077 10.643 1.83965 11.501C2.10059 11.894 3.77424 14.252 4.39911 15.125C4.37011 16.111 4.30113 18.646 4.29913 19.074C4.29613 20.0579 4.29415 20.708 4.84501 21.324C5.06996 21.576 5.56686 22 6.37069 22C6.7726 22 10.8447 20.787 11.9995 20.439ZM17.6018 15.1838C17.6437 16.6103 17.6991 18.7493 17.6999 19.0787C17.7021 19.8051 17.6963 19.9322 17.6736 19.9767C17.5616 19.9504 17.418 19.9144 17.2472 19.8699C16.8391 19.7634 16.2949 19.6126 15.6462 19.4271C14.6587 19.1447 13.4965 18.8013 12.5766 18.5241L11.9995 18.3502L11.4224 18.5241C10.5029 18.8012 9.34041 19.1447 8.35292 19.4271C7.7042 19.6126 7.16005 19.7634 6.75206 19.8699C6.58148 19.9145 6.43802 19.9504 6.32604 19.9766C6.30304 19.9326 6.2969 19.8071 6.29912 19.0801C6.30067 18.7488 6.35718 16.5803 6.39824 15.1838L6.41807 14.5095L6.02543 13.9609C5.19866 12.8058 3.70925 10.7011 3.50581 10.3947C3.01485 9.65422 2.98744 9.57977 3.00475 9.52653C3.02422 9.46662 3.06796 9.4373 3.87165 9.1432C4.20463 9.02058 6.39401 8.29883 7.79654 7.84477L8.40835 7.64669L8.79007 7.12916C9.57143 6.06978 11.1071 4.01707 11.3394 3.72674C11.8852 3.04281 11.9401 3 11.9995 3C12.049 3 12.0824 3.02198 12.403 3.40831C12.4693 3.48831 12.5251 3.55748 12.6586 3.72451C12.8889 4.01303 14.4014 6.03473 15.2108 7.1304L15.5929 7.64752L16.2047 7.84516C17.4867 8.25931 19.7877 9.01784 20.1229 9.1404C20.2134 9.17359 20.2145 9.17398 20.3015 9.20614C20.9377 9.44213 20.977 9.47051 20.9951 9.52605C21.0125 9.57968 20.9851 9.65415 20.4941 10.3939C20.2859 10.7088 18.8457 12.7438 17.9746 13.9609L17.5819 14.5095L17.6018 15.1838Z"
                fill="#5F6368"
              />
            </svg>
          </div>
          <div class="tab_text">
            Kids
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
    name: "App",
    components: {

    },
    data() {
        return {
            url: "https://oss.cloudofs.com/images/poster/2bbq1750351542332714.jpg",
            srcList: ["https://oss.cloudofs.com/images/poster/2bbq1750351542332714.jpg"],
            // PWA相关状态
            canInstall: false,
            isInstalled: false,
            installing: false,
            deferredPromptAvailable: false
        };
    },
    mounted() {
        this.initPWA();
    },
    created() {

    },
    
    // 清理事件监听器
    beforeDestroy() {
        window.removeEventListener('pwa-install-available', this.onInstallAvailable);
        window.removeEventListener('pwa-install-success', this.onInstallSuccess);
        window.removeEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
    },
    methods: {
        // 初始化PWA功能
        initPWA() {
            console.log('🚀 初始化PWA功能');
            
            // 检测浏览器支持
            this.checkBrowserSupport();
            
            // 检测是否已安装
            this.checkInstallStatus();
            
            // 初始化deferredPrompt状态
            this.deferredPromptAvailable = !!window.deferredPrompt;
            this.canInstall = !!window.deferredPrompt;
            
            // 设置事件监听器
            this.setupPWAEventListeners();
            
            // 延迟检查PWA条件（给浏览器时间触发beforeinstallprompt）
            setTimeout(() => {
                this.recheckPWAStatus();
            }, 3000);
        },
        
        // 检查浏览器支持
        checkBrowserSupport() {
            const support = {
                serviceWorker: 'serviceWorker' in navigator,
                manifest: 'manifest' in document.createElement('link'),
                standalone: 'standalone' in navigator || window.matchMedia('(display-mode: standalone)').matches,
                beforeInstallPrompt: 'onbeforeinstallprompt' in window
            };
            
            console.log('🔍 浏览器PWA支持情况:', support);
            
            if (!support.serviceWorker) {
                console.warn('⚠️ 浏览器不支持Service Worker');
            }
            if (!support.manifest) {
                console.warn('⚠️ 浏览器不支持Web App Manifest');
            }
        },
        
        // 检查安装状态
        checkInstallStatus() {
            // 检测是否在standalone模式运行（已安装）
            this.isInstalled = window.matchMedia('(display-mode: standalone)').matches || 
                              window.navigator.standalone === true;
            
            console.log('📱 PWA安装状态:', this.isInstalled ? '已安装' : '未安装');
        },
        
        // 重新检查PWA状态
        recheckPWAStatus() {
            console.log('🔄 重新检查PWA状态...');
            console.log('🔍 当前deferredPrompt状态:', !!window.deferredPrompt);
            
            this.deferredPromptAvailable = !!window.deferredPrompt;
            this.canInstall = !!window.deferredPrompt && !this.isInstalled;
            
            if (!window.deferredPrompt && !this.isInstalled) {
                console.log('💡 PWA安装条件检查:');
                console.log('   - HTTPS:', location.protocol === 'https:' || location.hostname === 'localhost');
                console.log('   - Service Worker:', 'serviceWorker' in navigator);
                console.log('   - Manifest:', document.querySelector('link[rel="manifest"]') !== null);
                console.log('   - 不在已安装状态:', !this.isInstalled);
            }
        },
        
        // 设置PWA事件监听器
        setupPWAEventListeners() {
            // 监听PWA安装可用事件
            window.addEventListener('pwa-install-available', this.onInstallAvailable);
            
            // 监听PWA安装成功事件
            window.addEventListener('pwa-install-success', this.onInstallSuccess);
            
            // 监听beforeinstallprompt事件
            window.addEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
        },
        
        // PWA安装可用时触发
        onInstallAvailable() {
            console.log('📢 PWA安装可用');
            this.canInstall = true;
            this.deferredPromptAvailable = !!window.deferredPrompt;
        },
        
        // PWA安装成功时触发
        onInstallSuccess() {
            console.log('🎉 PWA安装成功！');
            this.isInstalled = true;
            this.canInstall = false;
            this.installing = false;
            this.deferredPromptAvailable = false;
            this.showSuccessMessage();
            
            // 安装成功后跳转到首页
            setTimeout(() => {
                console.log('🚀 跳转到首页...');
                this.$router.push('/index');
            }, 1500); // 延迟1.5秒让用户看到成功消息
        },
        
        // beforeinstallprompt事件触发
        onBeforeInstallPrompt() {
            console.log('📥 收到beforeinstallprompt事件');
            this.canInstall = true;
            this.deferredPromptAvailable = !!window.deferredPrompt;
        },
        
        // 安装PWA
        async installPWA() {
            console.log('🚀 开始PWA安装流程...');
            
            // 如果已安装，直接提示
            if (this.isInstalled) {
                this.showAlreadyInstalledMessage();
                return;
            }
            
            // 检查是否有可用的安装提示
            if (!window.deferredPrompt) {
                console.log('❌ 没有可用的安装提示');
                
                // 诊断PWA条件
                this.diagnosePWAConditions();
                
                // 重新检查状态
                this.recheckPWAStatus();
                
                // 等待一小段时间，也许beforeinstallprompt事件正在路上
                setTimeout(() => {
                    if (!window.deferredPrompt) {
                        this.showManualInstallMessage();
                    } else {
                        console.log('✅ 重新检查后发现可以安装！');
                        this.canInstall = true;
                        this.deferredPromptAvailable = true;
                        // 可以选择自动重试安装
                        // this.installPWA();
                    }
                }, 1000);
                return;
            }
            
            this.installing = true;
            console.log('⏳ 显示安装提示...');
            
            try {
                // 显示安装提示
                window.deferredPrompt.prompt();
                console.log('👤 等待用户响应...');
                
                // 等待用户响应
                const { outcome } = await window.deferredPrompt.userChoice;
                
                console.log(`📊 用户选择: ${outcome}`);
                
                if (outcome === 'accepted') {
                    console.log('✅ 用户接受了安装');
                    // 注意：不要在这里立即设置状态，等待appinstalled事件
                } else {
                    console.log('❌ 用户拒绝了安装');
                    this.showCancelMessage();
                }
                
                // 清理
                window.deferredPrompt = null;
                this.canInstall = false;
                this.deferredPromptAvailable = false;
                
            } catch (error) {
                console.log(`💥 安装过程出错: ${error.message}`);
                this.showErrorMessage();
            } finally {
                this.installing = false;
            }
        },
        
        // 诊断PWA条件
        diagnosePWAConditions() {
            console.log('🔍 诊断PWA安装条件...');
            
            const conditions = {
                https: location.protocol === 'https:' || location.hostname === 'localhost',
                serviceWorker: 'serviceWorker' in navigator,
                manifest: !!document.querySelector('link[rel="manifest"]'),
                notInstalled: !this.isInstalled,
                userEngagement: true // 通常需要用户交互
            };
            
            console.log('📋 PWA安装条件检查:', conditions);
            
            const failedConditions = Object.entries(conditions)
                .filter(([, value]) => !value)
                .map(([key]) => key);
            
            if (failedConditions.length > 0) {
                console.warn('⚠️ 以下条件未满足:', failedConditions);
            }
            
            // 特别检查manifest文件
            this.checkManifestFile();
        },
        
        // 检查manifest文件
        async checkManifestFile() {
            try {
                const manifestLink = document.querySelector('link[rel="manifest"]');
                if (manifestLink) {
                    console.log('🔍 找到manifest链接:', manifestLink.href);
                    const response = await fetch(manifestLink.href);
                    if (response.ok) {
                        const manifest = await response.json();
                        console.log('✅ Manifest文件加载成功:', manifest);
                        console.log('📋 Manifest详情:');
                        console.log('   - 名称:', manifest.name);
                        console.log('   - 启动URL:', manifest.start_url);
                        console.log('   - 显示模式:', manifest.display);
                        console.log('   - 图标数量:', manifest.icons?.length || 0);
                        
                        // 再次检查PWA条件
                        setTimeout(() => {
                            this.recheckPWAStatus();
                        }, 500);
                    } else {
                        console.error('❌ Manifest文件加载失败:', response.status, response.statusText);
                        console.error('📍 请求URL:', manifestLink.href);
                    }
                } else {
                    console.error('❌ 未找到manifest链接');
                    console.log('💡 提示：请确保HTML中包含 <link rel="manifest" href="/manifest.json">');
                }
            } catch (error) {
                console.error('❌ 检查manifest文件时出错:', error);
            }
        },
        
        // 显示成功消息
        showSuccessMessage() {
            const message = 'Aplicativo instalado com sucesso! Redirecionando para a página inicial...';
            this.$notify({
                title: 'Sucesso!',
                message: message,
                type: 'success',
                duration: 4000
            });
        },
        
        // 显示已安装消息并跳转
        showAlreadyInstalledMessage() {
            const message = 'O aplicativo já está instalado! Redirecionando para a página inicial...';
            this.$notify({
                title: 'Informação',
                message: message,
                type: 'info',
                duration: 2000
            });
            
            // 已安装的情况下也跳转到首页
            setTimeout(() => {
                console.log('🚀 跳转到首页...');
                this.$router.push('/index');
            }, 1000);
        },
        
        // 显示取消消息
        showCancelMessage() {
            const message = 'Instalação cancelada. Você pode instalar a qualquer momento.';
            this.$notify({
                title: 'Cancelado',
                message: message,
                type: 'warning',
                duration: 3000
            });
        },
        
        // 显示错误消息
        showErrorMessage() {
            const message = 'Falha na instalação. Tente novamente ou instale manualmente.';
            this.$notify({
                title: 'Erro',
                message: message,
                type: 'error',
                duration: 4000
            });
        },
        
        // 显示手动安装说明
        showManualInstallMessage() {
            let message = '';
            let title = 'Instalação Manual';
            const userAgent = navigator.userAgent;
            
            // 检查是否是HTTPS问题
            if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
                title = 'Requer HTTPS';
                message = 'PWA requer conexão segura (HTTPS). Acesse o site via HTTPS para habilitar a instalação.';
            }
            // 检查浏览器支持
            else if (!('serviceWorker' in navigator)) {
                title = 'Navegador Não Suportado';
                message = 'Seu navegador não suporta PWA. Tente usar Chrome, Edge, Safari ou Firefox mais recente.';
            }
            // 正常的手动安装说明
            else if (/iPad|iPhone|iPod/.test(userAgent)) {
                // iOS设备
                message = 'Para instalar: toque no ícone de compartilhar (↗️) e selecione "Adicionar à Tela Inicial"';
            } else if (/Android/.test(userAgent)) {
                // Android设备
                message = 'Para instalar: toque no menu do navegador (⋮) e selecione "Instalar app"';
            } else {
                // 桌面设备
                message = 'Para instalar: procure pelo ícone de instalação (⬇️) na barra de endereços';
            }
            
            this.$notify({
                title: title,
                message: message,
                type: 'info',
                duration: 8000
            });
        }
    }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";

* {
    font-family: Roboto;
    scrollbar-width: none;
}

.dowloadApp {
    max-width: @maxWidth;
    position: fixed;
    height: 100%;
    left: 50%;
    transform: translateX(-50%); // overflow-y: hidden;
    width: 100%;
    overflow-y: auto;
}



.fontSize {
    font-size: .35rem !important;
}

.textColor {
    color: #5F6368;
}

.active {
    background-color: rgb(230, 243, 239, 1);
    color: rgb(2, 135, 96, 1) !important;
}

.app_h {
    position: fixed;
    box-sizing: border-box;
    width: 100%;
    max-width: @maxWidth;
    transform: translateX(-50%);
    top: 0;
    left: 50%;
    // margin-left: -50%;
    display: flex;
    // position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    contain: content;
    overflow: hidden;
    z-index: 10;
    box-sizing: border-box;
    min-height: 1rem;
    padding: .3rem .5rem .2rem .5rem;
    border-bottom: 0.05px solid #DDD;
    background-color: #F5F6F8;

    .left {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: inherit;
        object-position: inherit;
        width: 4rem;
        height: 1rem;
    }

    .right {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: inherit;
        object-position: inherit;
        width: 3rem;
        height: 1rem;
    }
}

p {
    margin: 0;
}

.content {
    padding: .7rem;
    box-sizing: border-box;
    background-color: #F5F6F8;
    margin-top: 1.5rem;

    .download {
        .download_h {
            display: flex;
            align-items: center;

            img {
                width: 1.8rem;
                border-radius: .4rem;
            }

            .flex-1 {
                flex: 1 1 0%;
            }

            .download_M {
                margin-left: .5rem;

                p {
                    font-size: .35rem;
                    margin: 0;
                    line-height: 1.3;
                    color: #5f6368;
                    font-family: "Roboto", "Helvetica Neue", sans-serif;
                }

                .text-2xl {
                    font-size: .55rem;
                    font-weight: 600;
                    color: #000;
                }

                .text-xl {
                    opacity: 1;
                    font-size: .45rem;
                    color: rgb(1, 135, 95, 1);
                    font-weight: 600;
                }
            }
        }

        .download_center {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 1rem;
            padding-right: .5rem;
            box-sizing: border-box;
            margin-top: .7rem;

            .items {
                text-align: center;
                font-size: .35rem;

                .text_1 {
                    font-weight: 700;
                    color: #000;
                }

                .text_2 {
                    color: #5f6368;
                    font-size: .3rem;
                }
            }
        }

        .download_btn {
            width: 100%;
            height: 1.4rem;
            background-color: #01875f;
            border-radius: .3rem;
            margin-top: .5rem;
            text-align: center;
            display: flex;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            transition: all 0.3s ease;

            .btn_h {
                display: flex;
                align-items: center;
                margin-top: .3rem;

                img {
                    width: .3rem;
                }

                span {
                    color: rgb(255, 227, 54, 1);
                    font-size: .37rem;
                    font-weight: 600;
                    margin-left: .1rem;
                }
            }

            .btn_b {
                color: #fff;
                font-size: .32rem;
                font-weight: 600;
            }
            
            .loading-spinner {
                font-size: .3rem;
                animation: spin 1s linear infinite;
            }

        }
        
        // PWA按钮状态样式
        .download_btn.installing {
            background-color: #5a9d73;
            cursor: wait;
            
            .btn_h span {
                color: rgba(255, 227, 54, 0.8);
            }
        }
        
        .download_btn.installed {
            background-color: #28a745;
            
            .btn_h span {
                color: #ffffff;
            }
            
            .btn_b span {
                color: rgba(255, 255, 255, 0.9);
            }
        }

        .download_bottom {
            color: rgb(1, 135, 95, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .37rem;
            font-weight: 700;
            margin-top: .5rem;
            cursor: pointer;

            span {
                color: rgb(1, 135, 95, 1);
                margin-left: .3rem;
                margin-right: .3rem;
            }
        }
    }

    .img_box {
        // overflow-x: auto;
        display: flex;
        margin-top: 1rem;

        .publicUrl {
            // width: 3.2rem;
            // height: 6rem;
            width: auto;
            height: 5rem;
            text-align: center;

            img {
                width: 90%;
                height: 100%;
            }
        }
    }

    .text_box {
        margin-top: 1rem;

        .text_title {
            display: flex;
            align-items: center;
            font-size: .45rem;
            font-weight: 700;
            color: rgb(32, 33, 36, 1);
            justify-content: space-between;

            img {
                width: .4rem;
            }
        }

        .text_content {
            font-size: .37rem;
            line-height: 0.7rem;
            color: #5F6368;
            font-weight: 700;
            opacity: .8;
        }

        .tag_box {
            display: flex;
            flex-wrap: wrap;
            cursor: pointer;

            .tag_item {
                padding-left: .3rem;
                padding-right: .3rem;
                padding-top: .1rem;
                padding-bottom: .1rem;
                border: 1px solid rgb(218, 220, 224, 1);
                border-radius: .5rem;
                font-size: .35rem;
                font-weight: 700;
                color: #5F6368;
                margin-right: .3rem;
                margin-top: .2rem;
                display: flex;
                align-items: center;

                img {
                    height: .4rem;

                }
            }
        }

        .rounded {
            padding: 0.7rem;
            border: 1px solid rgb(218, 220, 224, 1);
            border-radius: .3rem;

            .item_box {
                display: flex;
                align-items: flex-start;
                border: none;
                margin-bottom: .3rem;

                .item_img {
                    width: .5rem;
                    margin-right: .4rem;
                    margin-top: .1rem;

                    img {
                        width: 100%;
                    }
                }

                .item_text {
                    font-size: .35rem;
                    line-height: 0.6rem;

                    p {
                        font-size: .35rem;
                        font-weight: 700;
                        color: #5F6368;
                        opacity: 0.9;
                    }
                }
            }

            .item_bottom_text {
                color: #01875f;
            }
        }

        .game_box {
            display: grid;
            grid-gap: .5rem;
            grid-template-columns: repeat(2, 1fr);
            margin-top: .5rem;

            .game_item {
                display: flex;
                cursor: pointer;

                .game_img {
                    img {
                        border-radius: .2rem;
                        width: 50px;
                        height: 50px;
                    }
                }

                .game_content {
                    color: #202124;
                    font-size: .35rem;
                    display: grid;
                    height: fit-content;
                    row-gap: 2px;
                    margin-left: .2rem;

                    .game_title {
                        align-items: center;
                        display: inline-flex;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .game_star {
                        color: #5f6368;
                        font-size: .3rem;
                    }
                }
            }
        }
    }

    .fraction_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .5rem;

        .fraction {
            .fraction_title {
                font-size: 1.5rem;
                color: #000;
                font-weight: 700;
            }

            .fraction_star {

                img {
                    width: .4rem;
                }
            }

            .fraction_text {
                color: 5F6368;
                opacity: .9;
                margin-top: .3rem;
            }
        }

        .progress {

            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            // flex-direction: column;
            .progress_b {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .3rem;
                // flex-direction: column;
            }

            .progress_box {
                // border: 1px solid ;
                background-color: rgb(227, 227, 227, 1);
                width: 4.5rem;
                height: .3rem;
                border-radius: .5rem;
                margin-left: .3rem;

                .w-5 {
                    height: 100%;
                    background-color: rgb(2, 135, 96, 1);
                    border-radius: .5rem;
                }

                .w-4 {
                    height: 100%;
                    width: 10%;
                    background-color: rgb(2, 135, 96, 1);
                    border-radius: .5rem;
                }

                .w-3 {
                    height: 100%;
                    width: 10%;
                    background-color: rgb(2, 135, 96, 1);
                    border-radius: .5rem;
                }
            }
        }

    }

    .comment {
        margin-top: 1rem;

        .comment_box {
            .comment_item {
                margin-top: .5rem;

                .comment_top {
                    display: flex;
                    // justify-items: center;
                    align-items: center;
                    justify-content: space-between;

                    .comment_title {
                        display: flex;
                        align-items: center;
                        color: #5F6368;
                        font-size: .35rem;
                        font-weight: 700;
                        opacity: .9;

                        img {
                            width: 1rem;
                            height: 1rem;
                            border-radius: .5rem;
                            margin-right: .3rem;
                        }
                    }

                    .comment_img {
                        // width: .5rem;
                        height: .4rem;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .comment_star {
                    margin-top: .4rem;
                    margin-bottom: .4rem;

                    img {
                        width: .3rem;
                        margin-left: .2rem;
                    }

                    span {
                        color: #5F6368;
                        font-size: .35rem;
                        font-weight: 700;
                        opacity: .8;
                        margin-left: .5rem;
                    }
                }

                .comment_content {
                    color: #5F6368;
                    font-size: .37rem;
                    font-weight: 700;
                    margin-bottom: .5rem;
                    // opacity: .8;
                }

                .help_text {
                    display: flex;
                    align-items: center;
                    color: #5F6368;
                    font-size: .37rem;

                    .help_button {
                        display: flex;
                        align-items: center;
                        margin-left: .4rem;
                        font-size: .32rem;
                        cursor: pointer;

                        .button {
                            border-radius: .4rem;
                            border: 1px solid rgb(218, 220, 224);
                            padding: 0.05rem .4rem;
                            margin-left: .2rem;
                        }
                    }
                }
            }
        }


    }

    .line {
        height: 1px;
        background-color: rgb(218, 220, 224, 1);
        margin-top: 2rem;
    }

    .app_bottom {
        margin-top: .5rem;
        padding-bottom: 2rem;
        box-sizing: border-box;

        .bottom-1 {
            font-size: .35rem;
            font-weight: 700;
            color: #5F6368;
            opacity: 0.8;
            margin-bottom: 1rem;

            div {
                margin-bottom: .2rem;
            }
        }

        .bottom-2 {
            font-size: .35rem;
            font-weight: 700;
            color: #5F6368;
            opacity: 0.8;
            display: flex;
            margin-bottom: .5rem;

            div {
                margin-bottom: .2rem;

            }

            .last {
                margin-left: .5rem;
            }
        }

        .bottom-3 {
            display: flex;
            align-items: center;
            font-size: .35rem;
            margin-top: .5rem;
            font-weight: 700;
            color: #5F6368;
            // opacity: 0.8;

            div {
                margin-right: .3rem;
            }

            img {
                width: 0.6rem;
            }
        }

    }
}

.tab {
    box-shadow: 0 0.05263rem 0.10526rem -0.02632rem rgba(0, 0, 0, 0.2), 0 0.10526rem 0.13158rem 0 rgba(0, 0, 0, 0.14), 0 0.02632rem 0.26316rem 0 rgba(0, 0, 0, 0.12);
    position: fixed;
    bottom: 0;
    left: 50%;
    /* -webkit-transform: translateX(-50%); */
    transform: translateX(-50%);
    right: 0;
    width: 100%;
    max-width: @maxWidth;

    .footer-tabs {
        // display: flex;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 1rem;
        background-color: #f5f6f8;
        height: 2rem;
        padding: 12px 20px;
        box-sizing: border-box;
        text-align: center;

        .tab_text {
            font-size: .35rem;
            font-weight: 700;
            color: #5F6368;
            opacity: .8;
        }
    }
}

body {
    background-color: rgb(6, 63, 48);
    overscroll-behavior-y: none;
    -webkit-user-drag: none;
    overflow: hidden;
    height: 919px;
}

// CSS动画
@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
</style>
